import React, { Component } from "react";
import PropTypes from "prop-types";
import TextArea from "./TextArea";
import MultiSelect from "./MultiSelect";
import BooleanField from "./BooleanField";
import SingleSelect from "./SingleSelect";
import TextField from "./TextField";
import NextButton from "./NextButton";
import helpers from "../utils/helpers";

export default class Form extends Component {
  static propTypes = {
    questions: PropTypes.object,
    setQuestions: PropTypes.func,
    onSubmit: PropTypes.func,
  };

  state = {
    submitted: false,
  };

  onChange = (key, value) => {
    this.props.setQuestions({
      ...this.props.questions,
      [key]: value,
    });
  };

  validateData = (e) => {
    e.preventDefault();
    grecaptcha.ready(() => {
      grecaptcha
        .execute(CAPTCHA_SITE_KEY, { action: "submit" })
        .then((token) => {
          if (!this.validatingData) {
            this.setState({ submitted: true }, () => {
              helpers.validate(this.props.questions).then((valid) => {
                this.validatingData = false;
                if (valid) {
                  document.getElementById("submit").innerHTML =
                    "<div class='loader'></div>";
                  this.props.onSubmit(token);
                } else {
                  this.setState({ valid: false });
                }
              });
            });
          }
          this.validatingData = true;
        });
    });
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const firstName = searchParams.get("firstName") || "";
    const lastName = searchParams.get("lastName") || "";
    const email = searchParams.get("email") || "";
    const phone = searchParams.get("phone") || "";

    const updatedQuestions = {
      ...this.props.questions,
      name: `${firstName} ${lastName}`.trim(),
      email_address: email,
      phone: phone,
    };

    this.props.setQuestions(updatedQuestions);
  }

  render() {
    return (
      <form onSubmit={this.validateData} className="idea-form">
        <TextArea
          title="In a paragraph or two, tell us about your app idea. What problem does it solve and who is it for?"
          required={true}
          submitted={this.state.submitted}
          onChange={(value) => this.onChange("purpose", value)}
          value={this.props.questions.purpose}
        />
        <MultiSelect
          title="Where do you want your app to be found?"
          options={[
            {
              label: "Apple App Store",
              value: "ios",
              id: 1,
            },
            {
              label: "Google Play Store",
              value: "android",
              id: 2,
            },
            {
              label: "A Website",
              value: "web",
              id: 3,
            },
          ]}
          required={true}
          submitted={this.state.submitted}
          values={this.props.questions.platforms}
          onChange={(value) => this.onChange("platforms", value)}
        />
        <SingleSelect
          title="What stage is your project at?"
          options={[
            {
              label: "Just an idea",
              value: "idea",
              id: 1,
            },
            {
              label: "I have notes, sketches, or a basic plan",
              value: "basic",
              id: 2,
            },
            {
              label: "I have detailed wireframes or designs",
              value: "detailed",
              id: 3,
            },
          ]}
          required={true}
          submitted={this.state.submitted}
          value={this.props.questions.project_stage}
          onChange={(value) => this.onChange("project_stage", value)}
          name="stage"
        />
        <BooleanField
          title="Do you have a budget allocated for the first version of this project?"
          required={true}
          submitted={this.state.submitted}
          value={this.props.questions.budget}
          onChange={(value) => this.onChange("budget", value)}
        />
        <TextField
          title="Your Name"
          required={true}
          submitted={this.state.submitted}
          value={this.props.questions.name}
          onChange={(value) => this.onChange("name", value)}
        />
        <TextField
          title="Email Address"
          required={true}
          isEmail={true}
          submitted={this.state.submitted}
          value={this.props.questions.email_address}
          onChange={(value) => this.onChange("email_address", value)}
        />
        <TextField
          title="Phone Number (optional)"
          required={false}
          isPhone={true}
          submitted={this.state.submitted}
          value={this.props.questions.phone}
          onChange={(value) => this.onChange("phone", value)}
        />
        <div className="action-group">
          <NextButton id="submit" title="Submit" />
        </div>
      </form>
    );
  }
}
